import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-errors-details',
  templateUrl: './modal-errors-details.component.html',
  styleUrls: ['./modal-errors-details.component.sass']
})
export class ModalErrorsDetailsComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ModalErrorsDetailsComponent>,
  ) { }

  reprocessError() {
    this.dialogRef.close('reprocess');
  }

}
